'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgCalculator } from '@common/icon';
import { useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { SEARCH_PARAMS } from '@/constants';
import { GTM_EVENT_TYPE, trackGa4Event, trackGtmEvent } from '@/utils/analytics/gtm';
import { YouthSavingsCalculator } from './YouthSavingsCalculator';
interface YouthSavingsCalculatorTriggerProps {
  title: string;
  contentId: string;
}
export const YouthSavingsCalculatorTrigger = t0 => {
  const $ = _c(22);
  const {
    title,
    contentId
  } = t0;
  const [opened, setOpened] = useState(_temp);
  let t1;
  if ($[0] !== contentId || $[1] !== title) {
    t1 = () => {
      const eventParams = {
        btn_name: "\uAC08\uC544\uD0C0\uAE30\uACC4\uC0B0\uAE30",
        content_name: title,
        content_id: contentId
      };
      trackGtmEvent(GTM_EVENT_TYPE.CLICK_BTN, eventParams);
      trackGa4Event("click_btn", eventParams);
      setOpened(true);
    };
    $[0] = contentId;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpen = t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      bottom: "calc(max(var(--bottom-inset, 0px), 60px) + 92px)"
    };
    t3 = <SvgCalculator className="size-20" />;
    t4 = <span className="typo-body4">갈아타기 계산</span>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleOpen) {
    t5 = <button onClick={handleOpen} aria-label={"\uAC08\uC544\uD0C0\uAE30 \uACC4\uC0B0\uAE30 \uC5F4\uAE30"} className="fixed right-20 z-20 flex items-center gap-6 rounded-pill bg-B-500 px-16 py-12 font-700 text-Gray-white shadow-md transition-colors hover:bg-B-600 xl:hidden" style={t2}>{t3}{t4}</button>;
    $[6] = handleOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgCalculator className="size-20" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleOpen) {
    t7 = <div className="hidden xl:block"><Button theme="secondary-fill" dimensions="H48" className="w-full" onClick={handleOpen}>{t6}갈아타기 계산기</Button></div>;
    $[9] = handleOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpened(false);
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== contentId || $[13] !== title) {
    t9 = <div className="flex flex-col px-20 pb-32 mobile-tablet:min-h-full mobile-tablet:px-0"><YouthSavingsCalculator shareContext={{
        title,
        contentId
      }} /></div>;
    $[12] = contentId;
    $[13] = title;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== opened || $[16] !== t9) {
    t10 = <ResponsiveDialog opened={opened} onClose={t8} drawerType="full" isAppBarHeader={true} title={"\uAC08\uC544\uD0C0\uAE30 \uACC4\uC0B0\uAE30"}>{t9}</ResponsiveDialog>;
    $[15] = opened;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5 || $[20] !== t7) {
    t11 = <>{t5}{t7}{t10}</>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
function _temp() {
  return typeof window !== "undefined" && new URLSearchParams(window.location.search).get(SEARCH_PARAMS.ENTER_TYPE) === "share";
}